<template>

  <div>
    <el-row>
      <el-col :span="4">
        <el-scrollbar :height="tableHeight">
          <div class="type-main">
            <div class="type-add-btn">
              <el-button type="primary" @click="editTypeDialog(-1)">添加类目</el-button>
            </div>
            <div class="type-main-list">
              <div v-for="(item,index) of allTypeList" :key="index" class="type-list-item" :class="[infoLabelTypeId == item.id?'active':'']" @click="typeChange(item.id)">
                <div class="type-name" :class="[infoLabelTypeId == item.id?'activeName':'']">{{item.name}}</div>
                <div style="padding-right: 24px; white-space: nowrap">
                  <el-button type="text" @click.stop="editTypeDialog(index, item)">编辑</el-button>
                  <span v-if="item.state == 1" class="update-btn" style="color: red"  @click.stop="updateType(item, 2)" >下架</span>
                  <span v-if="item.state == 2" class="update-btn" @click.stop="updateType(item, 1)" >上架</span>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </el-col>
      <el-col :span="20">
        <el-scrollbar :height="tableHeight">
          <div class="table-main">
            <div class="content-button">
              <div>
                <div style="display: flex; align-items: center">
                  <div>
                    <label>状态：</label>
                    <el-select v-model="state" placeholder="Select" style="width: 6.4em">
                      <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div style="margin-left: 16px; display: flex; align-items: center">
                    <label style="white-space: nowrap">标签名称：</label>
                    <el-input v-model="searchValue" placeholder="请输入搜索内容" clearable @clear="getPage"/>
                  </div>
                  <div style="margin-left: 24px">
                    <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
                    <!--                <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
                  </div>
                </div>
              </div>
              <div>
                <el-button type="primary" @click="editTagDialog(-1)">新建标签</el-button>
              </div>
            </div>
            <el-table
                ref="multipleTableRef"
                :data="pageDataList"
                v-loading="listLoading"
                style="width: 100%"
                border
            >

              <el-table-column property="orderNum" label="图标">
                <template #default="scope">
                  <img v-if="scope.row.img" :src="scope.row.img" style="width: 24px; height: 24px" />
                </template>
              </el-table-column>
              <el-table-column property="name" label="标签名称" ></el-table-column>
              <el-table-column property="orderNum" label="排序"></el-table-column>
              <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
                <template #default="scope">
                  <span>{{ scope.row.state == 0 ? '待上架' : scope.row.state == 1 ? '已上架' : scope.row.state == 2 ? '已下架' : '' }}</span>
                </template>
              </el-table-column>
              <el-table-column property="" label="操作">
                <template #default="scope">
                  <el-space wrap>
                    <el-button size="small" @click="editTagDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                    <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">上架</el-button>
                    <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-if="scope.row.state == 0 || scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">下架</el-button>
                  </el-space>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
            </el-pagination>

          </div>
        </el-scrollbar>
      </el-col>
    </el-row>

  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getInfoLabelPageList, updateInfoLabelState, getInfoLabelTypePageList, updateInfoLabelTypeState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import TagInfoDialog from "./components/TagInfoDialog";
import TagTypeInfoDialog from "@/views/sys/components/TagTypeInfoDialog";

export default {
  name: "SysTag",
  components: {  },
  data() {
    return {

      allTypeList: [],
      active: 0,
      infoLabelTypeId: '',

      stateArray: [
        {label: '不限', value: -1},
        {label: "待上架", value: 0},
        {label: "已上架", value: 1},
        {label: "已下架", value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['标签类别', '排序', '标签内容', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      searchValue: '',

      searchLoading: false,
      listLoading: false,

      tableHeight: 0,

    }
  },
  methods: {


    typeChange(id) {
      this.infoLabelTypeId = id
      this.getPage()
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.state = -1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['searchValue'] = this.searchValue;
      param['infoLabelTypeId'] = this.infoLabelTypeId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getInfoLabelPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result.records;
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editTypeDialog(idx, row) {
      let _title = '';
      let tagForm = {}
      if (idx > -1) {
        _title = '编辑类目'
        tagForm = Object.assign({}, row);
      }else {
        _title = '新建类目'
      }
      Dialog.open({
        title: _title,
        component: TagTypeInfoDialog,
        data: {
          tagForm: tagForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getAllTypeList()
        }
      })
    },

    editTagDialog(idx, row) {
      let _title = '';
      let tagForm = {}
      if (idx > -1) {
        _title = '编辑标签'
        tagForm = Object.assign({}, row);
      }else {
        _title = '新建标签'
      }
      Dialog.open({
        title: _title,
        component: TagInfoDialog,
        data: {
          tagForm: tagForm,
          infoLabelTypeId: this.infoLabelTypeId,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateInfoLabelState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },

    getAllTypeList() {
      getFormData(getInfoLabelTypePageList).then(data => {
        this.allTypeList = data.data
        if(!this.infoLabelTypeId) {
          this.infoLabelTypeId = this.allTypeList[0].id
        }
        this.getPage()
      })
    },

    updateType(item, state) {
      this.$confirm('确认' + (state == 1?'上架':'下架') + '【' + item.name + '】？').then(()=> {
        postFormData(updateInfoLabelTypeState, {id: item.id, state: state}).then(data => {
          let {code,msg} = data;
          if(code == 200){
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.getAllTypeList()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      })
    },

    handleResize() {
      this.tableHeight = window.innerHeight - 48
    }


  },

  created() {
    this.handleResize()
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);


    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getAllTypeList()
    // this.getPage();
  }
}
</script>

<style scoped>
.type-main {
  /*width: 220px;*/
  /*margin-right: 24px;*/
  /*border-right: 1px solid #ebeef5;*/
  background-color: #f5f7fa;
  padding: 24px 0 24px 24px;
  min-height: calc(100vh - 96px);
}

.table-main {
  background-color: #ffffff;
  padding: 24px;
  /*width: 100%;*/
  flex: 1;
  min-height: calc(100vh - 96px);
}

.type-main-list{
  /*background-color: #f5f7fa;*/
  /*padding: 16px;*/
}

.type-add-btn {
  padding-bottom: 16px;
  /*border-right: 1px solid #ebeef5;*/
}

.type-name {
  white-space: nowrap;
  padding-left: 12px;
  /*border-left: 4px solid #f5f7fa;*/
  /*margin-right: 24px;*/
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.activeName {
  padding-left: 12px;
  /*border-left: 4px solid #3a8ee6;*/
  font-weight: bold;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.type-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*padding: 8px 0;*/
  /*border-left: 1px solid #ffffff;*/
  /*border-top: 1px solid #ffffff;*/
  /*border-bottom: 1px solid #ffffff;*/
  /*border-right: 1px solid #ebeef5;*/
  cursor: pointer;
  height: 48px;
  border-left: 4px solid #f5f7fa;
}

.active {
  /*border-left: 1px solid #ebeef5;*/
  /*border-top: 1px solid #ebeef5;*/
  /*border-bottom: 1px solid #ebeef5;*/
  /*border-right: 1px solid #ffffff;*/
  background-color: #ffffff;
  border-left: 4px solid #3a8ee6;
}

.update-btn {
  color: #42b983;
  padding-left: 12px;
  font-family: Arial;
}

</style>
